export default function libelle(type) {
    if ("CREATION" === type) {
        return "Création";
    } else if ("MODIFICATION" === type) {
        return "Modification";
    } else if ("DISSOLUTION" === type) {
        return "Dissolution";
    } else if ("RADIATION" === type) {
        return "Radiation";
    } else if ("RECTIFICATION" === type) {
        return "Rectification d'office";
    } else if ("FUSION_ABSORPTION" === type) {
        return "Fusion absorption";
    } else if ("RADIATION_OFFICE" === type) {
        return "Radiation d'office";
    }
    return null;
}

export function typeRequetes() {
    return [
        "CREATION",
        "MODIFICATION",
        "DISSOLUTION",
        "RADIATION",
        "FUSION_ABSORPTION",
        "RECTIFICATION",
        "RADIATION_OFFICE",
    ]
}

export function typeRequeteSelectItems() {
    return typeRequetes().map(value => ({ value, text: libelle(value) }));
}
